import React, { PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';

import './AdminNav.scss';

class AdminNavBar extends React.Component {
    render() {
        return (
            <div className="admin-nav">
                <IndexLink to="/">ROOT</IndexLink>
                <IndexLink to="/admin">Dash</IndexLink>
                {/*<Link to="/admin/pending">Pending</Link>*/}
                <Link to="/admin/order">New Book Order</Link>
                <Link to="/admin/history">Order History</Link>
            </div>
        );
    }
}

export default AdminNavBar;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminNav/AdminNav.js
 **/